import InstagramIcon from "@redotech/redo-icons/social-icon-instagram.svg";
import LinkedinIcon from "@redotech/redo-icons/social-icon-linkedin.svg";
import XIcon from "@redotech/redo-icons/social-icon-x.svg";
import CloseIcon from "@redotech/redo-icons/x-close.svg";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { RedoBaseModal } from "@redotech/redo-web/arbiter-components/modal/redo-base-modal";
import { JSXElementConstructor, memo } from "react";
import { OnboardingProps } from "../common";
import * as styles from "./giving-day-teaser-modal.module.css";
import givingDayImageUrl from "./giving-day-teaser.jpg?url";

const PARTICIPATION_STEPS = [
  "Comment on the launch post",
  "Drop a discount in the comments",
  "Repost so your audience can join in",
];

const SOCIAL_LINKS: {
  label: string;
  Icon: JSXElementConstructor<{ className?: string }>;
  url: string;
}[] = [
  {
    label: "LinkedIn",
    Icon: LinkedinIcon,
    url: "https://www.linkedin.com/posts/sterling-snow-051baab5_well-we-just-raised-81m-at-a-125b-valuation-ugcPost-7475200588691996673-JInC/?utm_source=share&utm_medium=member_desktop&rcm=ACoAABiPQb0BPWPbdpNsonlEYCzAGG2todtI4ZU",
  },
  {
    label: "X",
    Icon: XIcon,
    url: "https://x.com/sterlingmsnow/status/2069436034463789556?s=12&t=Zv7Qp8s1unMl6X52Vn8RpA",
  },
  {
    label: "Instagram",
    Icon: InstagramIcon,
    url: "https://www.instagram.com/reel/DZ7sGvxgxx-/?igsh=eGxrNGJ5anM4NGUx",
  },
];

export const GivingDayTeaserModal = memo(function GivingDayTeaserModal({
  handleDismiss,
}: OnboardingProps) {
  return (
    <RedoBaseModal
      darkMode
      isOpen
      onModalCloseRequested={handleDismiss}
      otherClasses={[styles.modal]}
    >
      <div className={styles.container}>
        <button
          aria-label="Close"
          className={styles.closeButton}
          onClick={handleDismiss}
          type="button"
        >
          <CloseIcon />
        </button>
        <div className={styles.content}>
          <p className={styles.eyebrow}>REDO GIVE BACK EVENT</p>
          <h2 className={styles.title}>A whole day, dedicated to you.</h2>
          <p className={styles.body}>
            Redo just launched our Give Back event as a thank you to brands
            building with us. For every brand tagged in the comments of our
            launch post, we&apos;ll pick one shopper and hand them{" "}
            <strong>$100 to spend with you</strong>, paid by Redo.
          </p>
          <p className={`${styles.eyebrow} ${styles.howTo}`}>
            HOW TO PARTICIPATE:
          </p>
          <div className={styles.steps}>
            {PARTICIPATION_STEPS.map((step, index) => (
              <div className={styles.stepCard} key={step}>
                <span className={styles.stepNumber}>{index + 1}</span>
                <span className={styles.stepLabel}>{step}</span>
              </div>
            ))}
          </div>
          <p className={styles.ctaLabel}>GO TO THE POSTS</p>
          <div className={styles.cta}>
            {SOCIAL_LINKS.map(({ label, Icon, url }) => (
              <RedoButton
                aria-label={label}
                buttonClassName={styles.socialButton}
                hierarchy="secondary"
                IconLeading={Icon}
                key={label}
                onClick={() =>
                  url && window.open(url, "_blank", "noopener,noreferrer")
                }
                size="lg"
                squared
              />
            ))}
          </div>
        </div>
        <img
          alt=""
          aria-hidden
          className={styles.image}
          src={givingDayImageUrl}
        />
      </div>
    </RedoBaseModal>
  );
});
